import { DecimalPipe, LowerCasePipe, SlicePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { Contractor } from '../../interfaces/contractor';

@Component({
  selector: 'app-contractor-cash-discount-cell',
  imports: [SlicePipe, TranslatePipe, LowerCasePipe, DecimalPipe],
  templateUrl: './contractor-cash-discount-cell.component.html',
  styleUrl: './contractor-cash-discount-cell.component.scss',
})
export class ContractorCashDiscountCellComponent {
  public readonly cashDiscount = input.required<
    Contractor['payment']['parameters']['cashDiscount'] | null
  >();

  protected readonly MAX_VISIBLE = 3;
}
